import { useMemo } from "react";

import { ILeanProductTileWithBrand } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { useRequestPageSize } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/useRequestPageSize";
import { useCategoryPageQuery } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/useCategoryPageQuery";
import { useIsCategoryPageLoading } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageLoading";

export const useCategoryPageProductFirstSearchResults =
  (): ILeanProductTileWithBrand[] => {
    const requestPageSize = useRequestPageSize();
    const isLoading = useIsCategoryPageLoading();
    const tiles = useCategoryPageQuery().data?.product_tiles;

    return useMemo(() => {
      if (isLoading) {
        return [];
      }

      return tiles?.slice(0, requestPageSize) ?? [];
    }, [isLoading, requestPageSize, tiles]);
  };
